import * as React from 'react'
import Link from 'next/link'
import styled from 'styled-components'

import * as entity from '@boutique/entities'
import * as utils from '@boutique/utils'
import * as components from '@bob/components'
import * as ds from '@bob/design-system'
import * as url from '@bob/url'

export type BrandsProps = {
  brands: entity.brand.ColdBrand[]
} & React.ButtonHTMLAttributes<HTMLElement>

function BrandsComponent({ brands, ...rest }: BrandsProps): React.ReactElement {
  return (
    <components.Section
      {...rest}
      title="Annuaire des marques"
      text={
        <>
          Repérage de marques qui prennent soin des humains et de la planète.{' '}
          <a href="https://consultation.bienoubien.com" rel="noopener noreferrer">
            Proposez vos idées !
          </a>
        </>
      }
      footer={
        <Link prefetch={false} href={url.brands().path} passHref legacyBehavior>
          <ds.ButtonAsLink autoSized>Voir toutes les marques</ds.ButtonAsLink>
        </Link>
      }
    >
      <ds.LineGridLayout>
        {brands.map((brand) => {
          return (
            <Link
              prefetch={false}
              key={brand.slug}
              href={url.brand({ slug: brand.slug, name: brand.name }).path}
              legacyBehavior
            >
              <a>
                <ds.BrandCard
                  // TODO: remove this ?? (contentful data is invalid now, but this should no longer be the case)
                  coverImage={brand.coverImage?.src ?? ''}
                  criteria={[...brand.pillars.environmental, ...brand.pillars.social].map((criterion) => ({
                    name: criterion.name,
                    icon: utils.symbols.getCriterionSymbolName(criterion.pillar.icon),
                  }))}
                  description={brand.descriptionShort}
                  logo={brand.logo}
                  name={brand.name}
                  signatory={brand.signatory}
                  tags={Array.from(new Set(brand.brandCategories.map((category) => category.name)))}
                />
              </a>
            </Link>
          )
        })}
      </ds.LineGridLayout>
    </components.Section>
  )
}

export const Brands = styled(BrandsComponent)``
